"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addCustomSchemaHandler = void 0;
var schema_item_1 = require("./components/schema-display/schema-item");
var control_1 = require("./components/schema-input/control");
/**
 * Registers a custom value display component and custom input component for a new input type.
 * @param inputType
 * @param customValue
 * @param customInput
 */
function addCustomSchemaHandler(inputType, customValue, customInput, getStringifiedFieldValue) {
    control_1.SchemaInputControl.registerComponent(inputType, customInput);
    schema_item_1.SchemaDisplayItem.registerComponent(inputType, customValue, getStringifiedFieldValue);
}
exports.addCustomSchemaHandler = addCustomSchemaHandler;
